"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var SearchImage = function SearchImage(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "gray",
    strokeWidth: "2",
    d: "M48.587 53.458L72.73 77.6l4.87-4.871-24.14-24.142h-4.71l1.4-1.647a27.77 27.77 0 0 0 6.629-18.051C56.778 13.486 44.29 1 28.888 1 13.487 1 1 13.486 1 28.889 1 44.29 13.486 56.778 28.889 56.778a27.77 27.77 0 0 0 18.05-6.629l1.648-1.4v4.71z"
  }));
};

SearchImage.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "79",
  height: "79",
  viewBox: "0 0 79 79"
};
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    root: {
      padding: spacing(2),
      paddingBottom: spacing(4)
    },
    content: {
      padding: spacing(2)
    }
  };
});

var EmptyListSearch = function EmptyListSearch(_ref2) {
  var search = _ref2.search;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column",
    alignItems: "center",
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(SearchImage, null), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column",
    alignItems: "center",
    className: classes.content
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Center-Static"
  }, "Well this is awkward\u2026"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Center-Static"
  }, "We couldn\u2019t find any results for \u201C", search, "\u201D.")), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Subcopy-Static-Alt"
  }, "Try adjusting your search terms."));
};

var _default = /*#__PURE__*/(0, _react.memo)(EmptyListSearch);

exports.default = _default;